
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, combineLatest, of } from "rxjs";
import { map, switchMap } from 'rxjs/operators'
// import { uniq, flatten } from 'lodash'

@Injectable({
  providedIn: "root"
})

export class ProductService {

  noAuthHeader = { headers: new HttpHeaders({ "Content-Type": "application/json"}) };

  constructor(
    private http: HttpClient,
    private firestore : AngularFirestore
    ) {}

  //HttpMethods
  joined$: Observable<any>


  //add product
  addProduct(data) {
    return this.http.post("add_product", data, this.noAuthHeader);
  }

  // edit product
  editProduct(form,id) {
    return this.firestore.collection("items").doc(id).update(form);
  }

  // editProductGKC
  editProductGKC(form,id) {
    return this.firestore.collection("items_private").doc(id).update(form);
  }

  // get product list
  getProductList(): Observable<any>{
    return this.firestore.collection("items", ref => ref.orderBy('date_created','desc')).snapshotChanges();
  }

  // Delete Product
  deleteProduct(id) {
    return this.firestore.collection("items").doc(id).delete();
  }
  
  // Get product by id
  getProductDetailById(productId:string): Observable<any>{
    return this.firestore.collection("items", ref => ref.where('id', '==', productId)).snapshotChanges();
  }

  // getProductGKCPriceById
  getProductGKCPriceById(productId:string): Observable<any>{
    return this.firestore.collection("items_private", ref => ref.where('item_id', '==', productId)).snapshotChanges();
  }
 
  // Add Product GKC
  addProductGKC(form) {
    form.id = this.firestore.createId();
    return this.firestore.collection("items_private").doc(form.id).set(form);
  }
}
